module.exports = __webpack_public_path__ + "static/media/corp_cf_7.e6487871.png";